import { Routes } from '@angular/router';
import { AuthGuard } from './utility/authentication/auth.guard';
import { RoleEnum } from './common/interfaces/token/role-enum';
import { MsalGuard } from '@azure/msal-angular';
import { ContactComponent } from './pages/contact/contact.component';
import { ContactSearchComponent } from './pages/contact-search/contact-search.component';
import { ContactIdGuard } from './utility/authentication/contact-id.guard';
import { quoteUnsavedGuard } from './pages/sales/quotes/quotes-details/quote-unsaved.guard';

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'Recent/',
    pathMatch: 'full'
  },
  {
    path: 'create-quote/:customerId',
    loadComponent: () => import('./pages/create-quote/create-quote.component').then(m => m.CreateQuoteComponent),
    canActivate: [MsalGuard],
    canMatch: [AuthGuard(RoleEnum.Sales, RoleEnum.ProjectManager)],
    data: { label: 'Create Quote' }
  },
  {
    path: 'Contact',
    redirectTo: 'Contact-Search/',
    pathMatch: 'full'
  },
  {
    path: 'Contact-Search',
    loadComponent: () => import('./pages/contact-search/contact-search.component').then(m => m.ContactSearchComponent),
    canActivate: [MsalGuard],
    canMatch: [AuthGuard(RoleEnum.Sales, RoleEnum.ProjectManager)],
    data: { label: 'Contact-Search' }
  },
  {
    path: 'Part-Search',
    loadComponent: () => import('./pages/global-part-lookup/global-part-lookup.component').then(m => m.GlobalPartLookupComponent),
    canActivate: [MsalGuard],
    canMatch: [AuthGuard(RoleEnum.Sales, RoleEnum.ProjectManager)],
    data: { label: 'Part-Search' }
  },
  {
    path: 'Contact/:contactID',
    component: ContactComponent,
    canActivate: [MsalGuard, ContactIdGuard],
    canMatch: [AuthGuard(RoleEnum.Sales, RoleEnum.ProjectManager)],
    data: { label: 'Contact' }
  },
  {
    path: 'Production/',
    loadComponent: () => import('./pages/activate-project/activate-project.component').then(m => m.ActivateProjectComponent),
    canActivate: [MsalGuard],
    canMatch: [AuthGuard(RoleEnum.ProjectManager)],
    data: { label: 'Production' }
  },
  {
    path: 'Production/:projectID',
    loadComponent: () => import('./pages/activate-project/activate-project.component').then(m => m.ActivateProjectComponent),
    canActivate: [MsalGuard],
    canMatch: [AuthGuard(RoleEnum.ProjectManager)],
    data: { label: 'Production Details' }
  },
  // Old Supplier-era URLs — keep bookmarks and recent-history entries working
  {
    path: 'Project/',
    redirectTo: 'Production/',
    pathMatch: 'full'
  },
  {
    path: 'Project/:projectID',
    redirectTo: 'Production/:projectID'
  },
  {
    path: 'sales',
    loadComponent: () => import('./pages/sales/sales.component').then(m => m.SalesComponent),
    canActivate: [MsalGuard],
    canMatch: [AuthGuard(RoleEnum.Sales, RoleEnum.ProjectManager)],
    data: { label: 'Sales' },
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/sales/sales-list/sales-list.component').then(m => m.SalesListComponent),
        data: { label: 'Sales List' }
      },
      {
        path: 'quotes/:quoteType',
        loadComponent: () => import('./pages/sales/quotes/quotes.component').then(m => m.QuotesComponent),
        data: { label: 'Quotes' }
      },
      {
        path: 'quote/:quoteID',
        loadComponent: () => import('./pages/sales/quotes/quotes-details/quotes-details.component').then(m => m.QuotesDetailsComponent),
        canDeactivate: [quoteUnsavedGuard],
        data: { label: 'Quote Details' }
      },
      {
        path: 'quote/order/:quoteID',
        loadComponent: () => import('./pages/sales/quotes/order/order.component').then(m => m.OrderComponent),
        data: { label: 'Order' }
      }

    ]
  },
  {
    path: 'Recent',
    loadComponent: () => import('./pages/recently-viewed/recently-viewed.component').then(m => m.RecentlyViewedComponent),
    canMatch: [AuthGuard(RoleEnum.Sales, RoleEnum.ProjectManager)],
    data: { label: 'Recently Viewed' }
  },
  {
    path: 'Whats-New',
    loadComponent: () => import('./pages/whats-new/whats-new.component').then(m => m.WhatsNewComponent),
    canActivate: [MsalGuard],
    canMatch: [AuthGuard(RoleEnum.Sales, RoleEnum.ProjectManager)],
    data: { label: "What's New" }
  },
  {
    path: 'Admin',
    loadComponent: () => import('./pages/admin/admin.component').then(m => m.AdminComponent),
    canActivate: [MsalGuard],
    canMatch: [AuthGuard(RoleEnum.Admin)],
    data: { label: 'Admin' }
  },
  {
    path: '**',
    redirectTo: 'Contact/'
  }
];
